export const countryProfile = {
  countrySummary: {
    text: "Résumé par pays",
    keyContacts: "Contacts clés",
    resources: "Ressources",
  },
  exportCountryDataButton: "DONNÉES DU PAYS EXPORTATEUR",
  downloadScorecard:
    "TÉLÉCHARGER CARTOGRAPHIE ET TABLEAU DE BORD - MATURITÉ SANTÉ NUMÉRIQUE",
  overallDigitalHealthPhase: "NIVEAU GLOBAL DE MATURITÉ DE LA SANTÉ NUMÉRIQUE",
  overallDigitalHealthPhaseDescription:
    "Le score global est une moyenne des scores des indicateurs de l'indice GDHM",
  benchmark: {
    text: "RÉFÉRENCE",
    textWithData: "RÉFÉRENCE: {data}",
    benchmarkValues: {
      globalAverage: "Moyenne mondiale",
      atAvg: "EN MOYEN",
      belowAvg: "EN DESSOUS DE LA MOYENNE",
      aboveAvg: "AU-DESSUS DE LA MOYENNE",
    },
    benchmarkDescription:
      "Comparez votre score global avec la moyenne mondiale ou d'autres pays en phase d'évaluation",
    benchmarkNoCountryForSelectedPhase:
      "Aucun pays dans la phase sélectionnée à comparer",
    serverErrorDescription:
      "Impossible de charger les données de référence. S'il vous plaît essayer après un certain temps",
    average: "Moyenne",
  },
  indicator: "l'indicateur",
  score: "Score",
  govtData: "Approuvées par le gouvernement",
  nonGovtData: "En attente de l'approbation du gouvernement",
  selectYear: "Sélectionnez l'année",
  selectYearDescription:
    "Pour afficher les données d'une année spécifique, veuillez sélectionner l'année souhaitée",
  phaseOverview: "Aperçu des phases",
  countryProgressOverTime: "Progrès du pays au fil du temps",
  countryProgressLineChart: {
    indicatorGroupingDescription: "Sélectionnez un indicateur",
    globalAverage: "Moyenne globale",
  },
  compareTo: "Comparer aux",
  region: "Région",
};
